import { createAction } from 'spw-redux/types';
import {
  AlternativeWorkpointsBreakdown,
  ProgramSummaryInterfaces,
  ProgramSummaryParams,
  UpdateSpacesByTypeParams,
} from './types';
import { IFloor, IBuilding, ProgramSummaryCardIcon } from '../projects/types';

export const ID_TYPE_URL_PARAM: { [key: string]: string } = {
  floorId: 'floor',
  buildingId: 'building',
  macro: 'macro',
  departments: 'departments',
};

export const ID_TYPE = {
  floorId: 'floorId',
  buildingId: 'buildingId',
  macro: 'macro',
  departments: 'departments',
};

export const GET_KEY_DATA = 'ps/GET_KEY_DATA';
export const GET_KEY_DATA_SUCCEEDED = 'ps/GET_KEY_DATA_SUCCEEDED';

export const GET_USF_TOTAL = 'ps/GET_USF_TOTAL';
export const GET_USF_TOTAL_SUCCEEDED = 'ps/GET_USF_TOTAL_SUCCEEDED';

export const GET_RSF_TOTAL = 'ps/GET_RSF_TOTAL';
export const GET_RSF_TOTAL_SUCCEEDED = 'ps/GET_RSF_TOTAL_SUCCEEDED';

export const GET_WORKSPACE_BREAKDOWN = 'ps/GET_WORKSPACE_BREAKDOWN';
export const GET_WORKSPACE_BREAKDOWN_SUCCEEDED =
  'ps/GET_WORKSPACE_BREAKDOWN_SUCCEEDED';

export const GET_SPACES_BREAKDOWN = 'ps/GET_SPACES_BREAKDOWN';
export const GET_SPACES_BREAKDOWN_SUCCEEDED =
  'ps/GET_SPACES_BREAKDOWN_SUCCEEDED';

export const GET_ALTERNATIVE_WORKPOINTS_BREAKDOWN =
  'ps/GET_ALTERNATIVE_WORKPOINTS_BREAKDOWN';
export const GET_ALTERNATIVE_WORKPOINTS_BREAKDOWN_SUCCEEDED =
  'ps/GET_ALTERNATIVE_WORKPOINTS_BREAKDOWN_SUCCEEDED';

export const GET_SEATS_OCCUPIED = 'ps/GET_SEATS_OCCUPIED_BY';
export const GET_SEATS_OCCUPIED_SUCCEEDED = 'ps/GET_SEATS_OCCUPIED_SUCCEEDED';

export const GET_WORKPLACE_BEHAVIOR = 'ps/GET_WORKPLACE_BEHAVIOR';
export const GET_WORKPLACE_BEHAVIOR_SUCCEEDED =
  'ps/GET_WORKPLACE_BEHAVIOR_SUCCEEDED';

export const UPDATE_SPACES_BY_TYPE = 'ps/UPDATE_SPACES_BY_TYPE';

export const SET_SELECTED_LEVELS = 'ps/SET_SELECTED_LEVELS';
export const SET_SUMMARY_SELECTED_ID_TYPE = 'ps/SET_SUMMARY_SELECTED_ID_TYPE';
export const setSelectedLevels = (levels: ProgramSummaryParams) =>
  createAction(SET_SELECTED_LEVELS, levels);

export const UPDATE_PROGRAM_SUMMARY_CARD_ICON =
  'ps/UPDATE_PROGRAM_SUMMARY_CARD_ICON';

export const setSummarySelectedIdType = (
  id: IFloor['id'] | IBuilding['id'],
  selectedType: string
) =>
  createAction(SET_SUMMARY_SELECTED_ID_TYPE, {
    selectedType,
    id,
  });

export const getUsfTotal = (params: ProgramSummaryParams) =>
  createAction(GET_USF_TOTAL, params);

export const getRsfTotal = (params: ProgramSummaryParams) =>
  createAction(GET_RSF_TOTAL, params);

export const getKeyData = (params: ProgramSummaryParams) =>
  createAction(GET_KEY_DATA, params);

export const getWorkspaceBreakdown = (params: ProgramSummaryParams) =>
  createAction(GET_WORKSPACE_BREAKDOWN, params);

export const getSpacesBreakDown = (params: ProgramSummaryParams) =>
  createAction(GET_SPACES_BREAKDOWN, params);

export const getAltWorkpointsBreakdown = (params: ProgramSummaryParams) =>
  createAction(GET_ALTERNATIVE_WORKPOINTS_BREAKDOWN, params);

export const getAltWorkpointsBreakdownSucceeded = (
  altWorkpointsBreakdown: AlternativeWorkpointsBreakdown
) =>
  createAction(
    GET_ALTERNATIVE_WORKPOINTS_BREAKDOWN_SUCCEEDED,
    altWorkpointsBreakdown
  );

export const getSeatsOccupied = (params: ProgramSummaryParams) =>
  createAction(GET_SEATS_OCCUPIED, params);

export const getWorkplaceBehavior = (params: ProgramSummaryParams) =>
  createAction(GET_WORKPLACE_BEHAVIOR, params);

export const updateSpacesByType = (payload: UpdateSpacesByTypeParams) =>
  createAction(UPDATE_SPACES_BY_TYPE, payload);

export const updateProgramSummaryCardIcon = (
  cardIcon: ProgramSummaryCardIcon
) => createAction(UPDATE_PROGRAM_SUMMARY_CARD_ICON, { cardIcon });

const actionCreatorSucceeded = (reducer: string) => (
  data: ProgramSummaryInterfaces
) => createAction(reducer, data);

export const actions = {
  getUsfTotal,
  getUsfTotalSucceeded: actionCreatorSucceeded(GET_USF_TOTAL_SUCCEEDED),
  getRsfTotal,
  getRsfTotalSucceeded: actionCreatorSucceeded(GET_RSF_TOTAL_SUCCEEDED),
  getWorkspaceBreakdown,
  getWorkspaceBreakdownSucceeded: actionCreatorSucceeded(
    GET_WORKSPACE_BREAKDOWN_SUCCEEDED
  ),
  getSpacesBreakDown,
  getSpacesBreakdownSucceeded: actionCreatorSucceeded(
    GET_SPACES_BREAKDOWN_SUCCEEDED
  ),
  getAltWorkpointsBreakdown,
  getAltWorkpointsBreakdownSucceeded,
  getSeatsOccupied,
  getSeatsOccupiedSucceeded: actionCreatorSucceeded(
    GET_SEATS_OCCUPIED_SUCCEEDED
  ),
  getWorkplaceBehavior,
  getWorkplaceBehaviorSucceeded: actionCreatorSucceeded(
    GET_WORKPLACE_BEHAVIOR_SUCCEEDED
  ),
  getKeyData,
  getKeyDataSucceeded: actionCreatorSucceeded(GET_KEY_DATA_SUCCEEDED),
  setSummarySelectedIdType,
  updateSpacesByType,
  updateProgramSummaryCardIcon,
};
